import { selectedDateRangeRest } from "../Pickers/dataRange";
import axios from "axios";
import { restErrorHandler } from "../../helpers/restErrorHandler";
import { RestApiState } from "./Organization";


export interface JournalResponse {
    count: number;
    next: string | null; // Assuming "next" can be null if there are no more pages
    previous: string | null; // Assuming "previous" can be null if there is no previous page
    results: JournalResults[] | undefined;
}


export type JournalResults = {
    created_at: string; // ISO 8601 formatted datetime string
    record_id: number;
    SNBattery: string; // Assumes the foreign key 'serial_number' is a string
    Time: number;
    TypeMessage: string; // Enum with limited choices
    CodeState: number; // Integer within range 1 to 65535
    CodeStateDisplay: string; 
    SOC: number; // Integer within range 0 to 100
    DOD: number; // Float within range 0 to 1_000_000
    SOH: number; // Integer within range 0 to 100
    Capacity: number; // Integer within range 10 to 10000
    NumFullDischCycles: number; // Integer within range 1 to 65535
    NumPartDischCycles: number; // Integer within range 1 to 65535
    ChargeCoulomb: number; // Float within range 0 to 9_999_999_999
    DischargeCoulomb: number; // Float within range 0 to 9_999_999_999
    EnergyCharge: number; // Float within range 0 to 9_999_999_999
    EnergyDischarge: number; // Float within range 0 to 9_999_999_999
    Voltage: number; // Float within range 8 to 1000
    Current: number; // Float within range -1000 to 1000
    Resistance: number; // Float within range 0 to 10000
    CellVoltageMin: number; // Float within range 0 to 5
    CVMinNumSlave: number; // Integer within range 1 to 30
    CVMinNumber: number; // Integer within range 1 to 32
    CellVoltageMax: number; // Float within range 0 to 5
    CVMaxNumSlave: number; // Integer within range 1 to 30
    CVMaxNumber: number; // Integer within range 1 to 32
    CellTempMin: number; // Float within range -273 to 200
    CTMinNumSlave: number; // Integer within range 0 to 30
    CTMinNumber: number; // Integer within range 1 to 32
    CellTempMax: number; // Float within range -273 to 200
    CTMaxNumSlave: number; // Integer within range 0 to 30
    CTMaxNumber: number; // Integer within range 1 to 32
    StateRele: Record<string, any>; // JSON object, replace 'any' with specific type if known
    StateInput: Record<string, any>; // JSON object
    StateOutput: Record<string, any>; // JSON object
    TimeIDEL: number; // Big integer for timestamp or long-duration representation
    TimeCharge: number; // Big integer
    TimeDischarge: number; // Big integer
    is_notified: boolean; // Boolean flag
};  


export type JournalParams = {
    limit:number;
    offset:number;
    currentPage: number;
}


function generateQueryString(params: any): string {
    // TODO function duped
    const queryString = Object.entries(params)
        .filter(([key, value]) => value !== undefined) // filter out undefined values
        .map(([key, value]) => {
            if (key === 'offset' && params.limit && params.currentPage) {
                value = (params.currentPage - 1) * params.limit
            }
            if (key === 'currentPage') {
                return null
            }

            if (key === 'dateRange') {
                key = 'period'
                value = selectedDateRangeRest(params.dateRange.range)
            }

            return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
        })
        .join('&'); // Join the key-value pairs with '&'

    return queryString ? `?${queryString}` : '';
}


export const fetchJournal = (serialNumber:string, role:string, setter: (value: JournalResponse) => void, params: JournalParams) => {
    axios.get<JournalResponse>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/journal${generateQueryString(params)}`,
        { withCredentials: true }
    )
    .then(response => {
        if (response.status === 200) {
            var data: JournalResponse = response.data;
            setter(data);
        }
    })
    .catch(error => {
        console.error('Error fetching accumulator details:', error);
        restErrorHandler(error.status);
    });
};

export const downloadJournal = (serialNumber:string, role:string, setter: (value: RestApiState) => void, params: JournalParams) => {
    setter(RestApiState.Pending);
    axios.get<any>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serialNumber}/journal-download${generateQueryString(params)}`,
        { withCredentials: true, responseType: 'blob' }
    )
    .then(response => {
        if (response.status === 200) {
            // Create a URL for the file
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);

            // Create an anchor element and trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${serialNumber}_logs.xlsx`); // Replace with the desired file name
            document.body.appendChild(link);
            link.click();
            
            if (link.parentNode) {
                // Clean up the URL and remove the element
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
           
            setter(RestApiState.Success);
        }
    })
    .catch(error => {
        setter(RestApiState.ServerError);
        // restErrorHandler(error.status);
    });
};